export * from './baseModel';
export * from './bot';
export * from './conversation';
export * from './entity';
export * from './interaction';
export * from './workspace';
export * from './activity';
export * from './integrations';
export * from './channel';
export * from './user';
export * from './faq';
export * from './responseElement';
export * from './fallbackRecognized';
export * from './analytics';
export * from './flow';

export interface BotdesignerContact {
    addresses: {
        city: string;
        country: string;
        countryCode: string;
        state: string;
        street: string;
        type: string;
        zip: string;
    }[],
    emails: {
        email: string;
        type: string;
    }[],
    ims: any[],
    name: {
        first_name: string;
        formatted_name: string;
        last_name: string;
    },
    org: {
        company: string;
    },
    phones: {
        phone: string;
        type: string;
    }[],
    urls: {
        url: string;
        type: string;
    }[]
}